// eslint-disable-next-line no-restricted-imports
import {useChatState} from '../utils/CopilotChatContext'
import {ChatWithCopilotHeader} from './ChatWithCopilotHeader'
import TopicList from './TopicList'
import styles from './TopicPicker.module.css'

export const TopicPicker = () => {
  const state = useChatState()

  return (
    <div className={styles.TopicPickerContainer}>
      <div className={styles.mainContentContainer}>
        <ChatWithCopilotHeader mode={state.mode} />
        <div className={styles.topicListContainer}>
          <TopicList />
        </div>
      </div>
    </div>
  )
}

try{ TopicPicker.displayName ||= 'TopicPicker' } catch {}